import { useEffect, useState } from "react";
import axios from "axios";
import { Modal } from "antd";

export default function AnnouncementModal() {
  const [announcement, setAnnouncement] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAnnouncementStatus = async () => {
      try {
        setLoading(true);
        const statusResponse = await axios.get("https://yzkz5stlh76wzugbkexmul3ba40rddkl.lambda-url.us-east-1.on.aws/get-announcement-status");
        console.log("Status Respone: ", statusResponse);
        if (statusResponse.data.show) {  // If announcement is enabled
          const response = await axios.get("https://uso7tjxxoe7g6drxmcy7m6lqiq0cyqeg.lambda-url.us-east-1.on.aws/announcement");
          if (response.data.content && response.data.content !== "No announcement found") {
            console.log("Response Data: ", response.data.content);
            setAnnouncement(response.data.content);
            setIsOpen(true);
          }
        }
      } catch (error) {
        console.error("Error fetching announcement status:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAnnouncementStatus();
  }, []);

  if (loading) return null; // Prevents UI flicker

  return (
    <Modal
      open={isOpen}
      onCancel={() => setIsOpen(false)}
      footer={null}
      closable={true}
      centered
      width={700}
    >
      <h2 className="text-2xl font-bold text-gray-800">📢 Announcement</h2>
      <div
        className="mt-4 text-gray-600"
        dangerouslySetInnerHTML={{ __html: announcement }}
      ></div>
    </Modal>
  );
}
